import * as yup from 'yup'

export type BillingFormValues = {
  companyName: string
  country: string
  state: string
  zip: string
  phone: string
  noCompany?: boolean
}

const basePhoneValidation = yup
  .string()
  .matches(/^\+?[0-9\s\-()]*$/, 'Invalid phone number')
  .min(10, 'Phone number too short')
  .max(15, 'Phone number too long')
  .nullable(true)

export const validationSchema = yup.object().shape({
  companyName: yup.string().nullable(),
  country: yup.string().required('Required'),
  state: yup.string(),
  zip: yup.string().required('Required'),
  phone: basePhoneValidation,
})

export const statesValidationSchema = yup.object().shape({
  companyName: yup.string().nullable(),
  country: yup.string().required('Required'),
  state: yup.string().required('Required'),
  zip: yup.string().required('Required'),
  phone: basePhoneValidation,
})

export const emptyFormValues: BillingFormValues = {
  companyName: '',
  country: '',
  state: '',
  zip: '',
  phone: '',
  noCompany: false,
}
